export enum CgiPollingStatus {
  IDLE = 'idle',
  WAITING_FOR_SIGNATURE = 'waiting',
  APP_OPEN = 'app-open',
  SIGNATURE_COMPLETE = 'complete',
  CANCELED = 'canceled',
  ERROR = 'error',
}

export enum CgiProvider {
  BankId = 'bankid',
  Freja = 'freja'
}

export type CgiAuthenticationType = 'same-device' | 'other-device';